var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffiliateStoreYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9845 5.99993C17.8945 5.6404 17.7112 5.311 17.4532 5.04498C17.1952 4.77896 16.8715 4.58575 16.5149 4.48485C15.2119 4.16669 10.0001 4.16669 10.0001 4.16669C10.0001 4.16669 4.78823 4.16669 3.48526 4.51515C3.12866 4.61605 2.80498 4.80926 2.54694 5.07528C2.28891 5.3413 2.10563 5.6707 2.01565 6.03023C1.77719 7.35255 1.66054 8.69394 1.66718 10.0376C1.65868 11.3914 1.77533 12.743 2.01565 14.0753C2.11486 14.4236 2.30223 14.7405 2.55966 14.9953C2.81711 15.25 3.13591 15.4341 3.48526 15.5298C4.78823 15.8782 10.0001 15.8782 10.0001 15.8782C10.0001 15.8782 15.2119 15.8782 16.5149 15.5298C16.8715 15.4289 17.1952 15.2356 17.4532 14.9696C17.7112 14.7036 17.8945 14.3742 17.9845 14.0147C18.2212 12.7023 18.3377 11.3711 18.333 10.0376C18.3415 8.68385 18.2248 7.3322 17.9845 5.99993Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 7.88776C8.125 7.49003 8.125 7.29116 8.20812 7.18013C8.28055 7.08338 8.39142 7.02285 8.512 7.01423C8.65033 7.00436 8.81758 7.11189 9.15217 7.32698L12.4378 9.43923C12.7282 9.62582 12.8733 9.71915 12.9235 9.83782C12.9672 9.94148 12.9672 10.0585 12.9235 10.1622C12.8733 10.2808 12.7282 10.3742 12.4378 10.5607L9.15217 12.673C8.81758 12.8881 8.65033 12.9957 8.512 12.9857C8.39142 12.9772 8.28055 12.9166 8.20812 12.8198C8.125 12.7088 8.125 12.51 8.125 12.1122V7.88776Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliateStoreYoutube);
export default __webpack_public_path__ + "static/media/affiliate-store-youtube.11880979a8fd12b7e20292af294e729e.svg";
export { ForwardRef as ReactComponent };